export default "__VITE_ASSET__D2340HYO__"